import { BaseComponent } from '../../../common/base-component/base-component';
import { ModalService } from '../../../services/modal.service';

export abstract class ModalComponent extends BaseComponent {
  constructor(protected modalService: ModalService) {
    super();
  }

  close(data?: any): void {
    this.modalService.close(data);
  }

  cancel(): void {
    this.modalService.cancel();
  }
}
